<ng-container *ngIf="cargandoCitas">
    <div fxLayout="column" fxLayoutAlign="space-between center">
        <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
        <h1>{{'CERTIFICAR.ADICIONALES.PREVIEW.LOADING' | translate}}</h1>
    </div>

</ng-container>


<mat-card class="example-card">
    <mat-card-header>
        <div mat-card-avatar class="example-header-image"></div>
        <mat-card-title *ngIf="!statusDate">{{'WIZARD.MEDICOS.TITULO' | translate}</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <ng-container *ngIf="statusDate && !cargandoCitas">

            <div class="mat-card mat-elevation-z4 p-24 mr-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto">
                <div fxLayout="row" class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayoutAlign="center center" fxFlex="1 0 auto">
                    <h2>{{'WIZARD.ALERT.LABEL02' | translate}}</h2>
                    <mat-icon class="ml-20 s-40">error_outline</mat-icon>
                </div>
            </div>


        </ng-container>

        <ng-container *ngIf="!statusDate && !cargandoCitas">
            <div fxLayout="row" fxLayoutAlign="start start" fxFlex="90">
                <mat-list>
                    <h3 mat-subheader>{{'WIZARD.DATE' | translate}}</h3>
                    <mat-list-item *ngFor="let date of arrayCitas">
                        <mat-icon></mat-icon>
                        <h4 mat-line>{{date.nombreColaborador}}</h4>
                        <p mat-line> {{date.nombreCentro}} / {{date.fecha}}</p>
                        <mat-divider></mat-divider>
                        <!--<p mat-line> {{date.fecha}} </p>-->
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </mat-list>

            </div>
        </ng-container>

    </mat-card-content>
    <mat-card-actions>
        <div fxLayout="row" fxLayoutAlign="space-evenly center">
            <button mat-button (click)="onNoClick()" fxFlex="50">{{'WIZARD.DATOSDOCTORES.ACCIONES.LABEL04' | translate}}</button>
        </div>
    </mat-card-actions>
</mat-card>